import React from "react";
import styled from "styled-components";
import Fade from "react-reveal/Fade";

function Section({
  title,
  description,
  leftBtnText,
  rightBtnText,
  backgroundImg,
}) {
  // console.log(props);
  return (
    <div className="section">
      <Wrap bgImage={backgroundImg}>
        <Fade bottom>
          <ItemText>
            <h1>{title}</h1>
            <p>{description}</p>
          </ItemText>
        </Fade>

        <Buttons>
          <Fade bottom>
            <ButtonGroup>
              <LeftButton>
                <LeftStyledLink href="/contact">{leftBtnText}</LeftStyledLink>
              </LeftButton>
              {rightBtnText &&
              <RightButton>
                <RightStyledLink href="/contact">{rightBtnText}</RightStyledLink>
              </RightButton>}
            </ButtonGroup>
            {leftBtnText !== "Shop now" ? (
              <DownArrow src="/images/down-arrow.svg" />
            ) : (
              ""
            )}
          </Fade>
        </Buttons>
      </Wrap>
    </div>
  );
}

export default Section;

const Wrap = styled.div`
  width: 100vw;
  height: 100vh;
  margin-top: 10px 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between; // vertical alignment
  align-items: center; // horizontal alignment
  background-image: ${(props) => `url("/images/${props.bgImage}")`};
  @media (max-width: 768px) {
    background-size: 180%;
  }
`;

const ItemText = styled.div`
  margin-top: 10px;
  padding-top: 15vh;
  text-align: center;
  font-size: 1rem;
  z-index: -1;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
  }
`;

const LeftButton = styled.div`
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  opacity: 0.85;
  text-transform: uppercase;
  font-size: 12px;
  cursor: pointer;
  margin: 8px;
`;

const RightButton = styled(LeftButton)`
  background: #f1f1f1;
  opacity: 0.65;
  color: black;
`;

const LeftStyledLink = styled.a`
  background-color: rgba(23, 26, 32, 0.8);
  height: 40px;
  width: 256px;
  color: white;                 /* Set the color to white */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  opacity: 0.85;
  text-transform: uppercase;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;        /* Remove underline */
  font-weight: 200;             /* Make the font thinner (lighter) */
  font-stretch: condensed;
  
  &:hover {
    opacity: 1;
  }
`;

const RightStyledLink = styled.a`
  height: 40px;
  width: 256px;
  color: black;                 /* Set the color to white */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  opacity: 0.85;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;        /* Remove underline */
  font-weight: 200;             /* Make the font thinner (lighter) */
  font-stretch: condensed;
  
  &:hover {
    opacity: 1;
  }
`;

const DownArrow = styled.img`
  margin-top: 10px;
  height: 40px;
  overflow-x: hidden; // hide scrollbar --> moved inside index.css
  animation: animateDown infinite 1.5s;
`;

const Buttons = styled.div`
  margin-bottom: 10px;
`;
